// eslint-disable-next-line import/no-anonymous-default-export
export default (posts = [], action) => {
  // Maps all action types with the request to return
  switch (action.type) {
    case "FETCH_ALL":
      return action.payload;
    case "LIKE":
      return posts.map((post) =>
        post.id === action.payload.id ? action.payload : post
      );
    case "CREATE":
      return [...posts, action.payload];
    case "UPDATE":
      return posts.map((post) =>
        post.id === action.payload.id ? action.payload : post
      );
    case "DELETE":
      return posts.filter((post) => post.id !== action.payload);
    default:
      return posts;
  }
};
